/**
 * tymczasowe tłumaczenia resposnów z usług
 * tylko na potrzeby prezentacji
 */

angular.module('ihestiaCommonDirectives.labelServiceHelper', [
  'ihestiaCommonDirectives.configHelper'
]);